(function(){
var T={
'v.vid1':{en:'3D-printing live',fi:'3D-tulostus livenä',de:'3D-Druck live'},
'v.vid2':{en:'Race3D on track',fi:'Race3D radalla',de:'Race3D auf der Strecke'},
'v.tag':{en:'Precision in every layer',fi:'Tarkkuutta joka kerroksessa',de:'Präzision in jeder Schicht'},
'v.title':{en:'From CAD file to<br>finished product',fi:'CAD-tiedostosta<br>valmiiksi tuotteeksi',de:'Von der CAD-Datei zum<br>fertigen Produkt'},
'v.sub':{en:'We 3D-print custom parts with industrial quality. Motorsport, prototypes, spare parts \u2014 all made in Sweden.',fi:'3D-tulostamme r\u00e4\u00e4t\u00e4l\u00f6ityj\u00e4 osia teollisella laadulla. Moottoriurheilu, prototyypit, varaosat \u2014 kaikki valmistettu Ruotsissa.',de:'Wir 3D-drucken ma\u00dfgeschneiderte Teile in Industriequalit\u00e4t. Motorsport, Prototypen, Ersatzteile \u2014 alles in Schweden gefertigt.'},
'v.cta1':{en:'Order print',fi:'Tilaa tulostus',de:'Druck bestellen'},
'v.cta2':{en:'See all products \u2192',fi:'Kaikki tuotteet \u2192',de:'Alle Produkte \u2192'},
'v.stat1':{en:'Parts delivered',fi:'Toimitettua osaa',de:'Gelieferte Teile'},
'v.stat2':{en: 'Manufacturing technology', fi: 'Valmistustekniikka', de: 'Fertigungstechnik'},
'v.stat3':{en:'Quote response',fi:'Tarjousvastaus',de:'Angebotantwort'},
'v.stat4':{en:'Countries',fi:'Maata',de:'L\u00e4nder'},
'c.tag':{en:'Configurator',fi:'Konfiguraattori',de:'Konfigurator'},
'c.title':{en:'Build your part',fi:'Rakenna osasi',de:'Baue dein Teil'},
'c.sub':{en: 'Choose material, color and size \u2014 get a preliminary estimate instantly.', fi: 'Valitse materiaali, v\u00e4ri ja mitat \u2014 saat alustavan arvion heti.', de: 'W\u00e4hle Material, Farbe und Ma\u00dfe \u2014 erhalte sofort eine vorl\u00e4ufige Sch\u00e4tzung.'},
'c.s1':{en:'Choose material',fi:'Valitse materiaali',de:'Material w\u00e4hlen'},
'c.s2':{en:'Choose color',fi:'Valitse v\u00e4ri',de:'Farbe w\u00e4hlen'},
'c.s3':{en:'Approximate dimensions',fi:'Likim\u00e4\u00e4r\u00e4iset mitat',de:'Ungef\u00e4hre Ma\u00dfe'},
'c.s4':{en:'Quantity & file',fi:'M\u00e4\u00e4r\u00e4 & tiedosto',de:'Menge & Datei'},
'c.pla':{en:'Standard \u2014 lightweight, nice finish',fi:'Standardi \u2014 kevyt, hyv\u00e4 viimeistely',de:'Standard \u2014 leicht, gutes Finish'},
'c.petg':{en:'Strong, chemical resistant',fi:'Vahva, kemikaalienkest\u00e4v\u00e4',de:'Stark, chemikalienbest\u00e4ndig'},
'c.abs':{en:'Heat resistant, impact tough',fi:'L\u00e4mm\u00f6nkest\u00e4v\u00e4, iskunkest\u00e4v\u00e4',de:'Hitzebest\u00e4ndig, schlagz\u00e4h'},
'c.nylon':{en:'Extreme durability, flexible',fi:'\u00c4\u00e4rimm\u00e4inen kest\u00e4vyys, joustava',de:'Extreme Haltbarkeit, flexibel'},
'c.tpu':{en:'Flexible, rubber-like',fi:'Joustava, kumimainen',de:'Flexibel, gummiartig'},
'c.resin':{en:'Ultra-fine detail, smooth surface',fi:'Ultrahieno yksityiskohta, sile\u00e4 pinta',de:'Ultrafeine Details, glatte Oberfl\u00e4che'},
'c.qty':{en:'Quantity',fi:'M\u00e4\u00e4r\u00e4',de:'Menge'},
'c.drop':{en:'Drop here or click',fi:'Pudota t\u00e4h\u00e4n tai napsauta',de:'Hierher ziehen oder klicken'},
'c.email':{en:'Email',fi:'S\u00e4hk\u00f6posti',de:'E-Mail'},
'c.msg':{en:'Message (optional)',fi:'Viesti (valinnainen)',de:'Nachricht (optional)'},
'c.est':{en: 'Preliminary material estimate', fi: 'Alustava materiaaliarvio', de: 'Vorl\u00e4ufige Materialsch\u00e4tzung'},
'c.mat':{en:'Material',fi:'Materiaali',de:'Material'},
'c.col':{en:'Color',fi:'V\u00e4ri',de:'Farbe'},
'c.dims':{en:'Dimensions',fi:'Mitat',de:'Ma\u00dfe'},
'c.vol':{en: 'Material volume (estimated)', fi: 'Materiaalitilavuus (arvio)', de: 'Materialvolumen (gesch\u00e4tzt)'},
'c.unit':{en:'Unit price',fi:'Yksikk\u00f6hinta',de:'St\u00fcckpreis'},
'c.qtyL':{en:'Quantity',fi:'M\u00e4\u00e4r\u00e4',de:'Menge'},
'c.total':{en:'Total (est.)',fi:'Yhteens\u00e4 (n.)',de:'Gesamt (ca.)'},
'c.vat':{en:'excl. VAT & shipping',fi:'alv ja rahti ei sis\u00e4lly',de:'zzgl. MwSt. & Versand'},
'c.send':{en:'SEND REQUEST',fi:'L\u00c4HET\u00c4 PYYNT\u00d6',de:'ANFRAGE SENDEN'},
'c.note':{en: 'Outer dimensions are not enough to calculate the exact material use of a part. The final price is given after reviewing geometry, material and quantity. Please state which dimensions and fits are critical.', fi: 'Ulkomitat eiv\u00e4t riit\u00e4 osan tarkan materiaalimenekin laskemiseen. Lopullinen hinta annetaan geometrian, materiaalin ja m\u00e4\u00e4r\u00e4n tarkastelun j\u00e4lkeen. Kerro, mitk\u00e4 mitat ja sovitteet ovat kriittisi\u00e4.', de: 'Die Au\u00dfenma\u00dfe reichen nicht aus, um den genauen Materialverbrauch zu berechnen. Der Endpreis folgt nach Pr\u00fcfung von Geometrie, Material und Menge. Bitte geben Sie kritische Ma\u00dfe und Passungen an.'},
'c.sending':{en:'Sending...',fi:'L\u00e4hetet\u00e4\u00e4n...',de:'Wird gesendet...'},
'c.length':{en:'LENGTH (MM)',fi:'PITUUS (MM)',de:'L\u00c4NGE (MM)'},
'c.width':{en:'WIDTH (MM)',fi:'LEVEYS (MM)',de:'BREITE (MM)'},
'c.height':{en:'HEIGHT (MM)',fi:'KORKEUS (MM)',de:'H\u00d6HE (MM)'},
'r.title':{en:'Customers who trust Race3D',fi:'Asiakkaat jotka luottavat Race3D:hen',de:'Kunden die Race3D vertrauen'},
'r.sub':{en:'From hobby builders to professional teams \u2014 we deliver quality',fi:'Harrastajista ammattilaistiimeihin \u2014 toimitamme laatua',de:'Von Hobbyisten bis zu Profiteams \u2014 wir liefern Qualit\u00e4t'},
'r.s1':{en:'Products delivered',fi:'Toimitettua tuotetta',de:'Gelieferte Produkte'},
'r.s2':{en:'Countries \u2014 Nordics, EU & USA',fi:'Maata \u2014 Pohjoismaat, EU & USA',de:'L\u00e4nder \u2014 Nordics, EU & USA'},
'r.s3':{en:'Custom-made \u2014 every part unique',fi:'R\u00e4\u00e4t\u00e4l\u00f6ity \u2014 jokainen osa uniikki',de:'Ma\u00dfgefertigt \u2014 jedes Teil einzigartig'},
'r.cta':{en:'Leave a review on Google',fi:'J\u00e4t\u00e4 arvostelu Googleen',de:'Bewertung auf Google hinterlassen'},
'rv.title':{en:'Recently viewed',fi:'\u00c4skett\u00e4in katsotut',de:'K\u00fcrzlich angesehen'},
'rv.clear':{en:'Clear',fi:'Tyhjenn\u00e4',de:'L\u00f6schen'},
'e.title':{en:"Wait, don't miss this!",fi:'\u00c4l\u00e4 miss\u00e4\u00e4 t\u00e4t\u00e4!',de:'Warte, verpasse das nicht!'},
'e.text':{en:'Get <strong>5% off</strong> your first order. Use this code at checkout:',fi:'Saat <strong>5% alennuksen</strong> ensimm\u00e4isest\u00e4 tilauksestasi. K\u00e4yt\u00e4 koodia kassalla:',de:'Erhalte <strong>5% Rabatt</strong> auf deine erste Bestellung. Nutze diesen Code:'},
'e.copy':{en:'Click to copy',fi:'Napsauta kopioidaksesi',de:'Klicken zum Kopieren'},
'e.cta':{en:'Shop now \u2192',fi:'Osta nyt \u2192',de:'Jetzt einkaufen \u2192'},
'e.skip':{en:'No thanks, just browsing',fi:'Ei kiitos, katson vain',de:'Nein danke, ich schaue nur'},
'ck.text':{en:'We use cookies to improve your experience and analyze traffic. Read our <a href="/policies/privacy-policy">privacy policy</a>.',fi:'K\u00e4yt\u00e4mme ev\u00e4steit\u00e4 parantaaksemme kokemustasi. Lue <a href="/policies/privacy-policy">tietosuojak\u00e4yt\u00e4nt\u00f6mme</a>.',de:'Wir verwenden Cookies, um Ihre Erfahrung zu verbessern. Lesen Sie unsere <a href="/policies/privacy-policy">Datenschutzrichtlinie</a>.'},
'ck.accept':{en:'Accept',fi:'Hyv\u00e4ksy',de:'Akzeptieren'},
'ck.decline':{en:'Decline',fi:'Hylk\u00e4\u00e4',de:'Ablehnen'}
};
var M=[
['.r3d-video-section__tag','v.tag'],
['.r3d-video-section__title','v.title'],
['.r3d-video-section__subtitle','v.sub'],
['.r3d-config__tag','c.tag'],
['.r3d-config__title','c.title'],
['.r3d-config__subtitle','c.sub'],
['#r3d-submit','c.send'],
['.r3d-config__note','c.note'],
['.r3d-hp-reviews__hd h2','r.title'],
['.r3d-hp-reviews__hd p','r.sub'],
['.r3d-recently-viewed__title','rv.title'],
['#r3d-rv-clear','rv.clear'],
['.r3d-cookie__text','ck.text'],
['#r3d-cookie-accept','ck.accept'],
['#r3d-cookie-decline','ck.decline'],
['.r3d-exit-popup h3','e.title'],
['.r3d-exit-popup p','e.text'],
['.r3d-exit-popup__cta','e.cta'],
['#r3d-exit-skip','e.skip']
];
var STATS=['v.stat1','v.stat2','v.stat3','v.stat4'];
var STEPS=['c.s1','c.s2','c.s3','c.s4'];
var MATS=['c.pla','c.petg','c.abs','c.nylon','c.tpu','c.resin'];

function run(){
var p=window.location.pathname;var lang=p.startsWith('/en')?'en':p.startsWith('/fi')?'fi':p.startsWith('/de')?'de':'sv';
if(lang==='sv')return;
document.querySelectorAll('[data-t]').forEach(function(el){
var v=T[el.getAttribute('data-t')];
if(v&&v[lang])el.innerHTML=v[lang];
});
M.forEach(function(p){
var el=document.querySelector(p[0]);
if(el){var v=T[p[1]];if(v&&v[lang])el.innerHTML=v[lang];}
});
document.querySelectorAll('.r3d-video-section__stat-label').forEach(function(el,i){
if(STATS[i]){var v=T[STATS[i]];if(v&&v[lang])el.textContent=v[lang];}
});
document.querySelectorAll('.r3d-config__step-title').forEach(function(el,i){
if(STEPS[i]){var v=T[STEPS[i]];if(v&&v[lang])el.textContent=v[lang];}
});
document.querySelectorAll('.r3d-config__material-desc').forEach(function(el,i){
if(MATS[i]){var v=T[MATS[i]];if(v&&v[lang])el.textContent=v[lang];}
});
document.querySelectorAll('.r3d-config__dim-group label').forEach(function(el,i){
var keys=['c.length','c.width','c.height'];
if(keys[i]){var v=T[keys[i]];if(v&&v[lang])el.textContent=v[lang];}
});
var ql=document.querySelector('label[for="r3d-qty"]');
if(ql){var v=T['c.qty'];if(v&&v[lang])ql.textContent=v[lang];}
var eml=document.querySelector('label[for="r3d-email"]');
if(eml){var v=T['c.email'];if(v&&v[lang])eml.textContent=v[lang];}
var ml=document.querySelector('label[for="r3d-msg"]');
if(ml){var v=T['c.msg'];if(v&&v[lang])ml.textContent=v[lang];}
document.querySelectorAll('.r3d-hp-trust-card__label').forEach(function(el,i){
var keys=['r.s1','r.s2','r.s3'];
if(keys[i]){var v=T[keys[i]];if(v&&v[lang])el.textContent=v[lang];}
});
var cta=document.querySelector('.r3d-video-section__cta--primary span, .r3d-video-section__cta--primary');
if(cta){var sp=cta.querySelector?cta.querySelector('span'):null;var tgt=sp||cta;var v=T['v.cta1'];if(v&&v[lang])tgt.textContent=v[lang];}
var cta2=document.querySelector('.r3d-video-section__cta--secondary span, .r3d-video-section__cta--secondary');
if(cta2){var sp2=cta2.querySelector?cta2.querySelector('span'):null;var tgt2=sp2||cta2;var v2=T['v.cta2'];if(v2&&v2[lang])tgt2.textContent=v2[lang];}
}
window.R3DT=T;
window.r3dRun=run;
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',function(){setTimeout(run,100);});}
else{setTimeout(run,100);}
setTimeout(run,500);
setTimeout(run,1500);
setTimeout(run,3000);
new MutationObserver(function(m){m.forEach(function(mu){if(mu.attributeName==='lang'){setTimeout(run,100);setTimeout(run,500);}});}).observe(document.documentElement,{attributes:true,attributeFilter:['lang']});
})();

